angular.module('cfn').directive('cfnCostsForm', [
  '$rootScope',
  '$log',
  '$timeout',
  'companyFinanceService',
  function($rootScope, $log, $timeout, companyFinanceService) {
    return {
      restrict: 'E',
      scope: {
        netpriceName: '@',
        netprice: '='
      },
      link: function(scope) {
        scope.$rootScope = $rootScope;
        scope.tax = companyFinanceService.getVatRate();
        scope.currencyunit = companyFinanceService.getCurrencyUnit();
      },
      controller: function() {
        var controller = {};
        return controller;
      },
      templateUrl: require('./cfn-costs-form.tpl.html')
    };
  }
]);
